import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

import { RootState } from '@/store/types';
import { AddressData } from '@/types';

export interface AddressDataState {
	address: AddressData | null;
}

export const state: AddressDataState = {
	address: null
};

export const actions: ActionTree<AddressDataState, RootState> = {
	updateAddress({ commit }, address: AddressData) {
		commit('UPDATE_ADDRESS', address);
	}
};

export const mutations: MutationTree<AddressDataState> = {
	UPDATE_ADDRESS(state, address: AddressData) {
		state.address = address;
	}
};

export const getters: GetterTree<AddressDataState, RootState> = {
	getAddress(state) {
		return state.address;
	}
};

export const addressData: Module<AddressDataState, RootState> = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
